<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.template_data_set_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="createTemplateDataset()"
    sbTooltip="{{ 'lang.globals.templateDatasets.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->


<sb-table-wrapper-new
  headline="{{'lang.globals.templateDatasets' | translate}}"
  [itemsData]="templateDatasets"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'templateDatasets'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section *ngPermissions="permissionService.Permission.template_group_list"
                         title="{{'lang.globals.areaCategories' | translate}}"
                         icon="templates">
        <sb-filter-dto-list-select filterID="templateGroups" [endpoint]="api.mm_templating_provider_TemplateGroup_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.templateGroup' | translate }}
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

  Table Body

------------------------------->
  <ng-template #tbody let-data>

    <tr>
      <td>
        {{ data?.id }}
      </td>
      <td>
          <sb-comp-link
            [condition]="permissionService.hasPermission(permissionService.Permission.template_data_set_entry_list)"
            [title]="data?.name"
            [link]="util.RoutingID.templateDatasetEntries"
            [pathParams]="[{id: 'templateDatasetID', value: data?.id}]"
            [tooltip]="'lang.globals.showEntries' | translate">
          </sb-comp-link>

      </td>
      <td>
        <sb-comp-link
          [title]="data?.group?.name"
          [permission]="permissionService.Permission.template_group_list"
          [link]="util.RoutingID.templateGroupsEdit"
          [pathParams]="[{id: 'templateGroupID',value: data?.group?.id}]">
        </sb-comp-link>
      </td>

      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="data.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>
